// extracted by mini-css-extract-plugin
module.exports = {"Block":"Licenses_Block__4MfKZ","Blocks":"Licenses_Blocks__B9DY7","Eyebrow":"Licenses_Eyebrow__ewEJ8"};